import { types, query, params, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';
import { Unpacked } from '../../../../../react-app-env';

const _editMenuInitQuery = (id: string) => ({
  organisation_by_pk: params(
    { id: rawString(id) },
    {
      name: types.string,
    }
  ),
});

type X = Unpacked<typeof _editMenuInitQuery>;
export type Organisation = X['organisation_by_pk'];

export const editMenuInitQuery = (id: string) => gql`
  ${query(_editMenuInitQuery(id))}
`;
